module.exports = __webpack_public_path__ + "img/artem-perov.9e2f136b.jpg";